import React, {memo, useEffect, useState} from "react";
import axios from "axios";
import ScrollArea from "react-scrollbar";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import "moment/locale/ru";
import Loading from "../../components/Loading";
import {MOMENT_LOCALE_DEFINITION} from "../../appConfig";

moment.updateLocale('ru', MOMENT_LOCALE_DEFINITION);

const filterDays = (date, dates) => !dates.includes(moment(date).format('YYYY-MM-DD'));

const Step2 = ({selectServiceId, selectedDay, setStep, setSelectedDay}) => {
    const [loading, setLoading] = useState(true);
    const [dates, setDates] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM-DD'));
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        axios({url: `/api/widget/service_dates?id=${selectServiceId}&date=${selectedMonth}`})
            .then(response => {
                const data = response.data.result;

                if(data) {
                    setDates(data.map(date => moment(date).format('YYYY-MM-DD')));
                    if(data.length) setSelectedDay(moment(data[0], 'YYYY-MM-DD'));

                } else {
                    setErrors(['Что-то пошло не так...']);
                }

                setLoading(false);
            })
            .catch(e => {
                if(e.isAxiosError && e.response) {
                    if(e.response.data.errors) {
                        setErrors(Object.keys(e.response.data.errors).map(key => `Ошибка ${key}: ${e.response.data.errors[key]}`));
                    } else {
                        setErrors([`Ошибка ${e.response.status}: ${e.response.statusText}`]);
                    }
                } else {
                    setErrors(['Что-то пошло не так...']);
                }

                setLoading(false);
            });
    }, [selectServiceId, selectedMonth, setSelectedDay]);

    const handleMonthChange = date => {
        setSelectedMonth(moment(date).format('YYYY-MM-DD'));
    };

    return loading ?
        <Loading/> :
        <div className="registration-for-service__step-2 step-2">
            {!errors.length ?
                <ScrollArea
                    className="step-2__wrap-scroll"
                    contentClassName="step-2__scroll"
                    verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                    verticalContainerStyle={{borderRadius: 8, width: 8}}
                    horizontal={false}
                    smoothScrolling={true}
                >
                    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="ru">
                        <DatePicker
                            variant="static"
                            openTo="date"
                            maxDate={moment().add(2, 'y')}
                            disablePast
                            disableToolbar
                            disable={!dates.length}
                            value={selectedDay}
                            onChange={date => {
                                setSelectedDay(moment(date).format('YYYY-MM-DD'));
                                if(dates.length) {
                                    setStep(3);
                                }
                            }}
                            onMonthChange={handleMonthChange}
                            shouldDisableDate={date => filterDays(date, dates)}
                        />
                    </MuiPickersUtilsProvider>
                    <div className="step-2__notify">
                        <p className="step-2__notify-black">Есть запись</p>
                        <p className="step-2__notify-grey">Нет записи</p>
                    </div>
                </ScrollArea> :
                <div className="registration-for-service__errors">
                    {errors.map((error, i) =>
                        <p key={`error-${i}`}>{error}</p>
                    )}
                </div>
            }
        </div>
};

export default memo(Step2);